import { Check, CircleX } from "lucide-react";

import { Mark } from "@/components/services/shared/demo-parts";

import type { LeadMessage } from "./lead-gen-demo-copy";

type CcLeadMessageProps = {
  channel: string;
  logo?: string;
  badge?: string;
  stateLabel: string;
  stateVariant: "before" | "after";
  to: string;
  message: LeadMessage;
  labels: { to: string; subject: string; chips: string };
};

/**
 * One outreach message as a neutral card (not LinkedIn's or Gmail's own UI):
 * recipient, optional subject, the message, then chips for what goes wrong
 * (before) or the signals it was built on (after), and the outcome.
 */
export function CcLeadMessage({
  channel,
  logo,
  badge,
  stateLabel,
  stateVariant,
  to,
  message,
  labels,
}: CcLeadMessageProps) {
  const StateIcon = stateVariant === "before" ? CircleX : Check;

  return (
    <div className={`cc-lead-message cc-lead-message--${stateVariant}`}>
      <div className="cc-auto-flow__bar">
        <span className="cc-auto-flow__name">
          <Mark logo={logo} badge={badge} />
          {channel}
        </span>
        <span className={`cc-auto-flow__state cc-auto-flow__state--${stateVariant}`}>
          <StateIcon className="cc-auto-flow__state-icon" size={11} strokeWidth={2.25} aria-hidden />
          {stateLabel}
        </span>
      </div>

      <div className="cc-lead-message__body">
        <p className="cc-lead-message__meta">
          <span>{labels.to}:</span> {to}
        </p>
        {message.subject ? (
          <p className="cc-lead-message__meta">
            <span>{labels.subject}:</span> <strong>{message.subject}</strong>
          </p>
        ) : null}
        <p className="cc-lead-message__text">{message.body}</p>
      </div>

      <div className="cc-lead-message__footer">
        <p className="cc-lead-message__chips-label">{labels.chips}</p>
        <ul className="cc-lead-message__chips">
          {message.chips.map((chip) => (
            <li key={chip.label}>
              <Mark logo={chip.logo} badge={chip.badge} />
              {chip.label}
            </li>
          ))}
        </ul>
        <p className="cc-lead-message__metric">{message.metric}</p>
      </div>
    </div>
  );
}
